// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"J_cG","breadcrumbs__link":"J_cH","breadcrumbs__link__active":"J_cJ","breadcrumbs__span":"J_cK"};